import { ActionTypes, doesWorkflowRejectCodeExist } from '@tassat/common-definitions';
import { IFormValues } from '@tassat/forms/src/AddCounterpartyForm/types';
import { AddressBookRecord, UserRecord } from '@tassat/fred-definitions';

import Worker from 'Lib/worker/PrimusWorker';
import { IFeaturesContext } from 'SharedComponents/hooks/useFeatures';

export const validateWalletExists = async (walletAddress: string, features: IFeaturesContext) => {
    try {
        const response = await Worker.getInstance()
            .getWalletAddressDetails({ WalletAddress: walletAddress });
        if (response.data.Status === 49) {
            return {
                error: true,
                message: 'Account is invalid or unable to receive'
            };
        } else {
            return response.data;
        }
    } catch (error) {
        return {
            error: true,
            message: 'Could not validate account, please try again'
        };
    }
};

export const submitAddCounterpartyForm = async (
    values: IFormValues,
    opts: {
        actionType: ActionTypes;
        user: UserRecord;
        isFavorited: boolean;
        contactForEdit: AddressBookRecord;
        setSubmitError: any;
        onClose: () => void;
    }
) => {
    const {
        actionType,
        user,
        isFavorited,
        contactForEdit,
        setSubmitError,
        onClose
    } = opts;

    try {
        let response = { data: undefined };
        if (actionType === ActionTypes.add) {
            const addAddressBookObj = {
                FirmId: user.FirmId,
                Account: values.Wallet,
                NickName: values.nickName1,
                IsFavorite: values.IsFavorite,
                AssociatedAccountNumber: values.AssociatedAccountNumber
            };

            response = await Worker.getInstance()
                .createAddressBookEntry(addAddressBookObj);
        } else if (actionType === ActionTypes.edit){
            const updatedAddressBookObj = {
                AddressBookId: contactForEdit.AddressBookId,
                NickName: values.nickName1,
                IsFavorite: values.IsFavorite,
                AssociatedAccountNumber: values.AssociatedAccountNumber
            };

            response = await Worker.getInstance()
                .modifyAddressBookEntry(updatedAddressBookObj);
        }

        if (response?.data.Status === 48) {
            onClose();
        } else if (response?.data.Status === 49 || doesWorkflowRejectCodeExist(response.data.Status)) {
            setSubmitError(`Could not add Counterparty: ${response.data.Reason}`);
        }
    } catch (error) {
        setSubmitError('Something went wrong');
    }
};